import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme } from "@themes";

export const GeneralStyle = styled.div`
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  h1 {
    text-align: left;
    color: ${({ theme }) => theme.primaryLight};
  }
  background-color: ${({ theme }) => theme.neutral.white};
  .MuiTabs-scroller {
    @media only screen and (max-width: 768px) {
      overflow-x: auto !important;
    }
  }
`;

export const TableViewButton = styled.div`
  border-radius: 1px;
  background: ${({ theme }) => theme.neutral.white};
  width: 40px;
  height: 40px;
  .list-view {
    color: ${({ iconColor, theme }) => (iconColor ? theme.text.primary : theme.tabs.selected)};
  }
  .card-view {
    color: ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
`;

export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  user-select: none;
  margin-left: 1.5rem;
  .right-section {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    @media only screen and (max-width: 425px) {
      flex-direction: column;
      align-items: flex-end;
    }
  }
  .table-action {
    margin-right: 20px;
    @media only screen and (max-width: 425px) {
      margin-top: 5%;
      margin-right: 5%;
    }
  }
`;

export const SearchField = styled.div`
  width: 240px;
  height: 40px;
  background: ${({ theme }) => theme.neutral.white};
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  svg {
    position: absolute;
  }
  input {
    font-size: 16px;
    font-weight: 400;
    border: none;
    outline: none;
    width: 85%;
    box-shadow: none;
    margin-left: 1rem;
  }
  input:focus {
    box-shadow: none;
    outline: none;
    border: none;
  }
  input::placeholder {
    color: #989898;
  }
  @media only screen and (max-width: 425px) {
    margin-right: 5%;
  }
`;

export const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.neutral.white,
  },
}));
